/* tslint:disable */

declare var Object: any;
export interface SInterface {
  "y": any;
  "id"?: number;
}

export class S implements SInterface {
  "y": any;
  "id": number;
  constructor(data?: SInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `S`.
   */
  public static getModelName() {
    return "S";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of S for dynamic purposes.
  **/
  public static factory(data: SInterface): S{
    return new S(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'S',
      plural: 's',
      path: 's',
      properties: {
        "y": {
          name: 'y',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/S.ts